export function removeShy(text: string) {
	return text.replaceAll(/&shy;/gi, '');
}
